import React from 'react'

import styled from 'styled-components'
import tw from 'tailwind.macro'

const StHero = styled.div`
  ${tw` relative pt-16`}
  background-color: #f2f7fc;
  min-height: 60vh;
  /* border: 2px solid #f0f; */
  .bg {
    border: 1px solid cornflowerblue;
    width: 100%;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    &:after {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background-image: linear-gradient(
        to right,
        rgba(242, 247, 252, 1),
        rgba(242, 247, 252, 1),
        rgba(242, 247, 252, 0)
      );
    }
  }
  .content {
    position: relative;
    z-index: 2;
  }
`

const Hero = () => {
  return (
    <StHero>
      <div className="content">
        <div className="mx-auto md:max-w-screen-sm sm:p-8 p-3">
          <h1 className="leading-none text-6xl mb-6">
            Ver y reflexionar: una nueva forma de aprender.
          </h1>
          <p className="text-xl leading-tight mt-0">
            La Facultad de Artes Liberales de la Universidad Adolfo Ibáñez lanza
            100 cápsulas audiovisuales e interdisciplinarias realizadas por sus
            académicos, con temáticas esenciales para apoyo al currículo escolar
            de séptimo básico a cuarto medio.{' '}
          </p>
          <p className="text-xl leading-tight mt-0">
            Cada cápsula aborda los objetivos de aprendizaje en las asignaturas
            de Historia, Filosofía, Ciencias, Lenguaje y Educación Ciudadana a
            través de la voz y el conocimiento de destacados especialistas de
            cada una de las cinco áreas.
          </p>
        </div>
      </div>
    </StHero>
  )
}

export default Hero
